import '../../styles/EduComponents/HeroSection1.css';
import dashboardImage from '../../assets/Images/hero2.webp';
import { Helmet } from 'react-helmet-async';

const HeroSection1 = () => {
  const handleClick = () => {
    const tidycalUrl = process.env.REACT_APP_TIDYCAL_URL; // replace with your actual TidyCal link
    try {
      window.open(tidycalUrl, '_blank', 'width=600,height=700');
    } catch (error) {
      console.error('Error opening TidyCal booking page:', error);
      alert('An error occurred while trying to open the booking page. Please try again later.');
    }
  };



  return (
    <section className="hero-container1">

<Helmet>
<link
    rel="preload"
    as="image"
    href={dashboardImage}
    type="image/webp"
  />
</Helmet>

      <div className="hero-text1">
        <h1>
          Built by Educators, For <span className="highlight">Educators</span> 
        </h1>
        <p>
            Discover the Freedom of teaching with Strawket
         
        </p>
        <div className="hero-buttons1">
          {/* {!isAuthenticated &&
             <a 
             href="https://strawket.com/login"  
             className="login-btn1"
           >
             Login
           </a>
          } */}
          <button onClick={handleClick} className="demo-btn1" aria-label="Book a demo through TidyCal">
     Book a Demo
    </button>
        </div>
      </div>

      <div className="hero-images1">
        <img src={dashboardImage} 
        alt="Strawket Dashboard Preview"
         width="800"
  height="819" // or actual dimensions
  loading="lazy" />
      </div>
    </section>
  );
};

export default HeroSection1;
